document.addEventListener("DOMContentLoaded", () => {
  // Find all disabled color options
  const disabledColorOptions = document.querySelectorAll(".product__color-option input[disabled]")

  // Remove the disabled attribute to make them clickable
  disabledColorOptions.forEach((option) => {
    // Only enable if it's not sold out
    const isSoldOut = option.closest(".product__option-value")?.classList.contains("sold-out")
    if (!isSoldOut) {
      option.removeAttribute("disabled")

      // Also remove the disabled class from the label
      const label = document.querySelector(`label[for="${option.id}"]`)
      if (label) {
        label.classList.remove("disabled")
      }
    }
  })

  // Add event listeners to handle color selection
  const colorOptions = document.querySelectorAll('.product__color-option input[type="radio"]')
  colorOptions.forEach((option) => {
    option.addEventListener("change", function () {
      // Get the selected color and size
      const selectedColor = this.value
      const selectedSize = document.querySelector('.product__option-value input[name="Size"]:checked')?.value

      if (selectedColor && selectedSize) {
        // Find the matching variant
        updateVariantSelection(selectedSize, selectedColor)
      }
    })
  })

  // Function to update the variant selection based on size and color
  function updateVariantSelection(size, color) {
    console.log(`Selecting variant with size: ${size}, color: ${color}`)

    // Find all variant options
    const variantOptions = document.querySelectorAll('select[name="id"] option, input[name="id"]')
    let variantId = null

    // Try to find the variant ID from data attributes if available
    const variantMap = window.productVariants || {}
    if (variantMap[`${size}-${color}`]) {
      variantId = variantMap[`${size}-${color}`]
    } else {
      // Otherwise try to find it from the option elements
      variantOptions.forEach((option) => {
        const optionText = option.textContent || option.value
        if (optionText.includes(size) && optionText.includes(color)) {
          variantId = option.value
        }
      })
    }

    // If we found a matching variant, select it
    if (variantId) {
      console.log(`Found matching variant ID: ${variantId}`)
      const variantInput = document.querySelector('input[name="id"]')
      if (variantInput) {
        variantInput.value = variantId
      }

      // Update the product image if needed
      updateProductImage(variantId)
    } else {
      console.warn(`No matching variant found for size: ${size}, color: ${color}`)
    }
  }

  // Function to update the product image based on the selected variant
  function updateProductImage(variantId) {
    const variantImage = document.querySelector(`[data-variant-id="${variantId}"] img`)
    if (variantImage) {
      const mainImage = document.querySelector(".product__gallery-main .active img")
      if (mainImage) {
        mainImage.src = variantImage.src
      }
    }
  }
})
